import { render, staticRenderFns } from "./xunjianjilu.vue?vue&type=template&id=23f9f8f5&scoped=true"
import script from "./xunjianjilu.vue?vue&type=script&lang=js"
export * from "./xunjianjilu.vue?vue&type=script&lang=js"
import style0 from "./xunjianjilu.vue?vue&type=style&index=0&id=23f9f8f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9f8f5",
  null
  
)

export default component.exports